import { Box, Stack, Typography } from '@mui/material'
import useGetThemeColor from '@/hooks/useGetThemeColor'
import { WorkflowStateAction } from '@/types/workflow-state-actions'
import { useSelectedWorkflowContext } from '@/components/workflows/SelectedWorkflowProvider'

type PurchaseOrderMatchDisplayProps = {
  action: WorkflowStateAction
}

export default function PurchaseOrderMatchDisplay({
  action,
}: PurchaseOrderMatchDisplayProps) {
  const getThemeColor = useGetThemeColor()
  const { selectedWorkflow } = useSelectedWorkflowContext()
  const cleanMatchStateId: string | undefined =
    action.params.clean_match_workflow_state_id || undefined

  const workflowState = selectedWorkflow.workflow_states?.find(
    ({ id }) => id === cleanMatchStateId,
  )

  return (
    <Stack direction="column" spacing={0.5}>
      <Typography variant="body2" color="text.secondary">
        PixyAI will match the invoice to an open purchase order. If the match
        has <b>no unmatched lines or discrepancies</b>, the document will move
        to{' '}
        {cleanMatchStateId ? (
          <Box
            component="span"
            sx={{ color: getThemeColor(workflowState?.color) }}
          >
            {workflowState?.name}
          </Box>
        ) : (
          'the next workflow state'
        )}
        .
      </Typography>
      <Typography variant="body2" color="text.secondary">
        If there <b>are unmatched lines or discrepancies</b>, the document will
        stay in the current workflow state for review.
      </Typography>
      <Typography variant="body2" color="text.secondary">
        If <b>purchase order matching is disabled</b> for the document&apos;s
        company or vendor, the document will move to the next workflow state.
      </Typography>
    </Stack>
  )
}
